import { z } from "zod";
import { photoUrl } from "./appointments";
import { recordId } from "./contracts";
import { clearableText, clearableWebAddress, SETTINGS_DESCRIPTION_MAX_LENGTH, SETTINGS_SHORT_TEXT_MAX_LENGTH, settingsName } from "./organization-settings";

export const profile = z.object({
  id: recordId,
  name: z.string(),
  email: z.string(),
  phone: z.string().nullable(),
  description: z.string().nullable(),
  location: z.string().nullable(),
  twitter: z.string().nullable(),
  linkedin: z.string().nullable(),
  avatar: z.string().nullable(),
});
export type Profile = z.infer<typeof profile>;

export const profileRequest = z
  .object({
    name: settingsName,
    phone: clearableText(SETTINGS_SHORT_TEXT_MAX_LENGTH),
    description: clearableText(SETTINGS_DESCRIPTION_MAX_LENGTH),
    location: clearableText(SETTINGS_SHORT_TEXT_MAX_LENGTH),
    twitter: clearableWebAddress,
    linkedin: clearableWebAddress,
  })
  .strict();
export type ProfileRequest = {
  name: string;
  phone?: string | null;
  description?: string | null;
  location?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
};

export const avatarRequest = z.object({ avatarUrl: photoUrl }).strict();
export type AvatarRequest = z.infer<typeof avatarRequest>;
